import { Component, OnInit } from '@angular/core';
import { deofuscate } from '@/utils/obfuscation';
import { Router, ActivatedRoute } from '@angular/router';
import { Breadcrumbs } from '@/shared/breadcrum/breadcrum.component';
import { Location } from '@angular/common';
import { normalize } from '@/utils/normalizeString';
import { CompleteLicenseWithDate } from '@/interfaces/dashboard/licenses';
import { RequirementService } from '@/services/requirement/requirement.service';
import { catchError, map } from 'rxjs/operators';

type Variant = 'LICENSE' | 'REQUEST';

@Component({
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.css'],
})
export class ShowComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private requirementService: RequirementService,
  ) { }

  email: string = '';
  id: number = 0;
  licenseId: number = 0;
  variant: Variant = 'REQUEST';

  licenseData?: CompleteLicenseWithDate;
  licenseDataGetting: boolean = true;
  licenseDataError: boolean = false;

  showDocumentsLinks: boolean = false;

  personRutDv?: string;

  get documents(): CompleteLicenseWithDate['documents'] {
    if (this.licenseData) {
      return this.licenseData.documents;
    }
    return [];
  }

  get equipments(): CompleteLicenseWithDate['equipments'] {
    if (this.licenseData) {
      return this.licenseData.equipments;
    }
    return [];
  }

  breadcrums: Breadcrumbs = [
    { text: 'Inicio', path: '/dashboard' },
    { text: 'Solicitar', path: '/license/new' },
  ]

  ngOnInit() {
    this.route.params.pipe().subscribe(({ ofuscatedData }) => {
      const { id, variant } = deofuscate(ofuscatedData);
      if (!id) {
        this.router.navigateByUrl('/dashboard');
        return;
      }
      if (variant) {
        this.showDocumentsLinks = true;
        if (normalize(variant) === normalize('LICENSE')) {
          this.variant = 'LICENSE';
          this.requirementService.getLicenseById(id).pipe(
            catchError((err) => this.requirementService.getDeletedLicenseById(id)),
          )
            .pipe(map((license) => ({ ...license, documents: license.documents.filter((x) => !x.isMineRequired && x.name !== '') })))
            .subscribe({
              next: (license) => {
                this.licenseData = license;
                this.personRutDv = license.userRutDv;
                this.licenseDataGetting = false;
              },
              error: () => {
                this.licenseDataGetting = false;
                this.licenseDataError = true;
              },
            });
        }
        else {
          this.id = id;
        }
      }
      else {
        this.id = id;
      }
    });
  }

  onGoBack() {
    this.location.back();
  }
}
